import styled from "styled-components";

const PrimaryButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  border-radius: 8px;
  background-color: var(--primaryColor);
  opacity: ${(props) => (props.disabled ? 0.65 : 1)};
  color: #fff;
  outline: 0;
  border: 0;
  -webkit-appearance: button;
  transition: opacity 0.5s ease;
  ${(props) => (!props.disabled ? "cursor: pointer;" : "")}
  text-transform: none;
  font-family: inherit;
  line-height: inherit;
  &: hover
    ${(props) =>
      !props.disabled &&
      `{
    background-color: var(--primaryColorActive);
    border-color: ;  var(--primaryColorActiveBorder);
  }`};
`;

const SecondaryButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  border-radius: 8px;
  background-color: #fff;
  opacity: ${(props) => (props.disabled ? 0.65 : 1)};
  color: #8f9294;
  outline: 1px solid;
  border: 0;
  -webkit-appearance: button;
  transition: opacity 0.5s ease;
  ${(props) => (!props.disabled ? "cursor: pointer;" : "")}
  text-transform: none;
  font-family: inherit;
  line-height: inherit;
  &: hover
    ${(props) =>
      !props.disabled &&
      `{
    color: #fff;
    background-color: #ccc;
    border-color: #ccc;
  }`};
`;

export const Button = (props) => {
  const { variant } = props;
  switch (variant) {
    case "secondary":
      return <SecondaryButton {...props} />;
    default:
      return <PrimaryButton {...props} />;
  }
};
